module.exports = __webpack_public_path__ + "static/5-42f61bbef0e142867a2a449840760dc0.svg";